export const breakpoint = {
  tiny: '640px',
  small: '768px',
  medium: '1024px',
  large: '1280px',
  huge: '1536px',
} as const;
